export default __webpack_public_path__ + "static/jepsen-b0fce5cd69c4d377393fe8a3b6dfb444.jpg";